export const START_SCREENING = "START_SCREENING";
export const SCREENING_ID = "SCREENING_ID";
